/* Spec PWA-025 — dificulta copiar o conteudo do app (fotos e dados de criancas) e abrir o inspecionar pelos atalhos.
   E so uma barreira para o uso comum (D-01): o menu do navegador, captura de tela e a rede continuam abertos. */

/* Onde o padrinho digita: seleciona, copia, recorta, cola e tem menu de contexto (D-03). */
const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]'
/* Conteudo que o app oferece para copiar de proposito (Pix copia-e-cola, linha digitavel). */
const ALLOW_COPY_SELECTOR = '[data-allow-copy]'

type ProtectionEnv = { DEV?: boolean; VITE_SPONSOR_CONTENT_PROTECTION?: string }

/* D-05: ligada no build, desligada em dev; a variavel forca um ou outro. */
export function isContentProtectionEnabled(env: ProtectionEnv): boolean {
    if (env.VITE_SPONSOR_CONTENT_PROTECTION === 'true') return true
    if (env.VITE_SPONSOR_CONTENT_PROTECTION === 'false') return false
    return !env.DEV
}

type ClosestTarget = { closest?: (selector: string) => unknown }

function matches(target: unknown, selector: string): boolean {
    const node = target as ClosestTarget | null
    if (!node || typeof node.closest !== 'function') {
        // Texto solto: o alvo e o no de texto; vale o elemento pai.
        const parent = (target as { parentElement?: unknown } | null)?.parentElement
        return parent ? matches(parent, selector) : false
    }
    return node.closest(selector) != null
}

export function isEditableTarget(target: unknown): boolean {
    return matches(target, EDITABLE_SELECTOR)
}

export function allowsCopy(target: unknown): boolean {
    return isEditableTarget(target) || matches(target, ALLOW_COPY_SELECTOR)
}

type ShortcutEvent = { key: string; code: string; ctrlKey: boolean; metaKey: boolean; shiftKey: boolean; altKey: boolean }

/* D-04: F12, Ctrl+Shift+I/J/C, Cmd+Option+I/J/C, Ctrl/Cmd+U e Ctrl/Cmd+S. Usa `code` (tecla fisica): no Mac,
   Option muda o caractere de `key`. */
export function isBlockedShortcut(event: ShortcutEvent): boolean {
    if (event.key === 'F12' || event.code === 'F12') return true
    const mod = event.ctrlKey || event.metaKey
    if (!mod) return false
    if ((event.shiftKey || event.altKey) && ['KeyI', 'KeyJ', 'KeyC'].includes(event.code)) return true
    if (!event.shiftKey && !event.altKey && ['KeyU', 'KeyS'].includes(event.code)) return true
    return false
}

/* Instala os bloqueios no documento; devolve a funcao que desfaz. */
export function installContentProtection(doc: Document): () => void {
    const selectionAllowsCopy = (event: Event) => {
        if (allowsCopy(event.target)) return true
        const selection = doc.getSelection()
        return !!selection && selection.rangeCount > 0 && allowsCopy(selection.anchorNode) && allowsCopy(selection.focusNode)
    }
    const onCopy = (event: Event) => {
        if (!selectionAllowsCopy(event)) event.preventDefault()
    }
    const onContextMenu = (event: Event) => {
        if (!allowsCopy(event.target)) event.preventDefault()
    }
    const onDragStart = (event: Event) => {
        if (!isEditableTarget(event.target)) event.preventDefault()
    }
    const onKeyDown = (event: KeyboardEvent) => {
        if (isBlockedShortcut(event)) {
            event.preventDefault()
            event.stopPropagation()
        }
    }

    doc.documentElement.dataset.contentProtection = ''
    doc.addEventListener('copy', onCopy, true)
    doc.addEventListener('cut', onCopy, true)
    doc.addEventListener('contextmenu', onContextMenu, true)
    doc.addEventListener('dragstart', onDragStart, true)
    doc.addEventListener('keydown', onKeyDown, true)

    return () => {
        delete doc.documentElement.dataset.contentProtection
        doc.removeEventListener('copy', onCopy, true)
        doc.removeEventListener('cut', onCopy, true)
        doc.removeEventListener('contextmenu', onContextMenu, true)
        doc.removeEventListener('dragstart', onDragStart, true)
        doc.removeEventListener('keydown', onKeyDown, true)
    }
}
